import {createContext} from 'react'

export const AnalyticsCompareProductsContext = createContext<any>({
  products: [],
  isLoading: false,
  filters: {},
  onSearch: () => {},
  onSortingChange: () => {},
  checkedRows: [],
  setCheckedRows: () => {},
  meta: {},
  onDateChange: () => {},
})
